import React, { useState, useRef, useEffect, useMemo } from 'react';
import FilterBox from './components/FilterBox';
import FilterFixedHeader from './components/FilterFixedHeader';
import useFilterFixed from './hooks/useFilterFixed';
import classNames from 'classnames';
import './index.scss';
import {
  deleteFilterSaveSelectedValue,
  deleteFilterStorageValue,
  deleteFilterSaveValue,
} from '@gp/utils/utils';

const FilterCommon = (props: any) => {
  const {
    confirm,
    localGameInfo,
    userInfo,
    noLimitation = false,
    isAccountRegion = false,
    styles = {},
    hideTop,
    pageName,
    style,
    controls,
    value,
    onChange: handleChange,
    isNeedDiff,
    fields,
    onReset,
    loading,
    setIsOverFiler,
    filterSearchHeight,
    filterHeight: filterHeightProps = 76,
    scrollBody,
    headerTitle,
    headerOther,
    showRightBtn,
    currentPage,
    formatSearchResults,
    updateDeps,
    handleSearch,
    getSearchList,
    hasSearchBtn,
    isHaveFilterSave = true,
    selectedValue,
    setSelectedValue,
    searchList,
    setSearchList,
    searchVal,
    setSearchVal,
    searchPlaceholder,
    ...otherProps
  } = props;

  // const ref = useRef<HTMLDivElement>(null);
  const commonFilterRef = useRef(null);
  const filterBoxRef = useRef(null);
  const [filterName, setFilterName] = useState<string | undefined>(undefined);
  const [selectShow, setSelectShow] = useState(false);
  const [minHeight, setMinHeight] = useState(0);
  const [filterHeight, setFilterHeight] = useState(128 + filterHeightProps);

  const { filterFixed, filterSearchFixed } = useFilterFixed({
    scrollBody,
    filterHeight,
    filterSearchHeight,
    // selectShow,
  });

  const backConfirm = () => {
    confirm?.();
    setSelectShow(false);
  };

  const onResetHandle = () => {
    onReset?.();
    setSelectShow(false);
    // 删除缓存值
    deleteFilterStorageValue();
    deleteFilterSaveValue();
    deleteFilterSaveSelectedValue();
  };

  useEffect(() => {
    const handleResize = () => {
      if (commonFilterRef.current) {
        const filterRefHeight =
          commonFilterRef.current?.getBoundingClientRect().height;
        if (filterRefHeight > 130) {
          setIsOverFiler?.(true);
        } else {
          setIsOverFiler?.(false);
        }
      } else {
        setIsOverFiler?.(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [loading]);

  const toggle = () => {
    const value = !selectShow;
    setTimeout(() => {
      setSelectShow(value);
    }, 100);
  };

  const close = () => {
    setSelectShow(false);
  };

  const classNameCur = useMemo(() => {
    let text = 'dbg-filterfixed-wrapper';
    if (filterSearchFixed) {
      text += ' dbg-filterbox-fixed filter-visiable';
    }

    if (selectShow) {
      text += ' filter-expand';
    }
    return text;
  }, [filterSearchFixed, selectShow, filterFixed]);

  useEffect(() => {
    const element = filterBoxRef.current;
    if (!element) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target.offsetHeight && entry.target.offsetTop) {
          setMinHeight(entry.target.offsetHeight);
          setFilterHeight(
            entry.target.offsetTop +
              entry.target.offsetHeight +
              filterHeightProps,
          );
        }
      }
    });
    resizeObserver.observe(element);
    return () => {
      resizeObserver.unobserve(element);
    };
  }, [selectShow]);

  return (
    <div
      className={classNames('dbg-filter-common dbg-filterbox', {
        'filter-box-show': selectShow,
        'dbg-filter-box-none': filterFixed,
      })}
      style={{ minHeight, ...styles }}
    >
      <div className="dbo-filterbox-ref" ref={filterBoxRef}>
        <div className={classNameCur}>
          {/* 吸顶区域 */}
          <FilterFixedHeader
            filterName={filterName}
            filterValue={value}
            fields={fields}
            controls={controls}
            isAccountRegion={isAccountRegion}
            change={toggle}
            filterSearchFixed={filterSearchFixed}
            filterFixed={filterFixed}
            headerTitle={headerTitle}
            headerOther={headerOther}
            showRightBtn={showRightBtn}
            currentPage={currentPage}
            formatSearchResults={formatSearchResults}
            updateDeps={updateDeps}
            handleSearch={handleSearch}
            getSearchList={getSearchList}
            hasSearchBtn={hasSearchBtn}
            selectedValue={selectedValue}
            searchList={searchList}
            setSearchList={setSearchList}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
            searchPlaceholder={searchPlaceholder}
          />
        </div>
        <div className={filterFixed ? 'dbg-filterbox-header' : ''}>
          <FilterBox
            userInfo={userInfo}
            {...otherProps}
            isAccountRegion={isAccountRegion}
            confirm={backConfirm}
            noLimitation={noLimitation}
            filterName={filterName}
            setFilterName={setFilterName}
            style={style}
            controls={controls}
            value={value}
            onChange={handleChange}
            isNeedDiff={true}
            fields={fields}
            onReset={onResetHandle}
            loading={loading}
            close={close}
            filterSearchFixed={filterSearchFixed}
            selectShow={selectShow}
            filterFixed={filterFixed}
            currentPage={currentPage}
            isHaveFilterSave={isHaveFilterSave}
            setSelectedValue={setSelectedValue}
            selectedValue={selectedValue}
            isFilter={true}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterCommon;
